import type { Logger } from "@expert/logging";
import type { Partner } from "@expert/shared-types";
import ky from "ky";
import { defaultHeaders, defaultTimeoutInMS } from "../types";

interface LookupMdnsPayload {
    partner: Partner;
    callSid: string;
    sessionId: string;
}

export interface AccountMdn {
    masked: string;
    value: string;
}

interface LookupMdnsResult {
    success: boolean;
    accountFound: boolean;
    mdnsAvailable: boolean;
    accountMdns: AccountMdn[];
    token: string;
}

export const lookupMdns = async (
    ssoAccessToken: string,
    payload: LookupMdnsPayload,
    verifyCustomerToken: string,
    logger: Logger,
) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/api/device-activation/v1/lookup-account-mdns`;
        const resp = await ky.post(url, {
            headers: {
                ...defaultHeaders,
                Authorization: `Bearer ${ssoAccessToken}`,
            },
            json: { ...payload, callSid: payload.callSid || "mocked-call-sid", token: verifyCustomerToken },
            timeout: defaultTimeoutInMS,
        });

        return await resp.json<LookupMdnsResult>();
    } catch (error) {
        logger.error({ error }, `Error: Could not lookup account MDN for customer MDN.`);
        return { success: false, accountFound: false, mdnsAvailable: false, accountMdns: [], token: "" };
    }
};
